<template>

    <nav class="bg-darken pt-spc47 pb-spc33">
        <ul class="main-menu flex flex-col items-center">
            <li class="mb-spc51">
                <router-link class="text-2xl font-medium inline-block text-white tracking-spc1" to="#">Pricing</router-link>
            </li>
            <li class="mb-spc51">
                <router-link class="text-2xl font-medium inline-block text-white tracking-spc1" to="#">Templates</router-link>
            </li>
            <li class="mb-spc51">
                <router-link class="text-2xl font-medium inline-block text-white tracking-spc1" to="#">Apps</router-link>
            </li>
            <li class="mb-spc51">
                <router-link class="text-2xl font-medium inline-block text-white tracking-spc1" to="#">Features</router-link>
            </li>
            <li class="mb-spc51">
                <router-link class="text-2xl font-medium inline-block text-white tracking-spc1" to="#">Customers</router-link>
            </li>
            <li class="dots">
                <router-link class="text-2xl font-medium inline-block text-white tracking-spc1 flex items-center" to="#">
                    <span class="w-spc10 h-spc10 bg-white rounded-full mr-spc11"></span>
                    <span class="w-spc10 h-spc10 bg-white rounded-full mr-spc11"></span>
                    <span class="w-spc10 h-spc10 bg-white rounded-full"></span>
                </router-link>
            </li>
            <li class="flex items-center mt-spc22">
                <router-link class="text-2xl font-medium inline-block text-white tracking-spc1 uppercase mr-spc54" to="#">Login</router-link>
                <ThemeButton  title="Create An Account" url="#" />
            </li>
        </ul>
    </nav>
</template>

<script>
    import ThemeButton from "./ThemeButton";
    export default {
        name: "MobileMenu",
        components: {
            ThemeButton
        }
    }
</script>

<style scoped>

</style>